import { Dispatch } from 'redux';
import { updateNosRollout } from '../actions/event';
import { getNosRollout as getNosRolloutApi } from '../api/nosRollout';
import { getEventId, getEventOrganizationId } from '../selectors/event';
import { CheckoutState } from '../state';

export const getNosRollout =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const eventId = getEventId(getState());
        const organizationId = getEventOrganizationId(getState());

        let scenario = null;
        let isNosSourceOfTruth = false;

        try {
            const { response } = await getNosRolloutApi({
                eventId,
                organizationId,
            });

            scenario = response.scenario;
            isNosSourceOfTruth = response.nos_source;
        } catch {}

        await dispatch(
            updateNosRollout({
                scenario,
                isNosSourceOfTruth,
            }),
        );
    };
